import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchLobbyByCode } from "../lib/api.js";

export function JoinByCodePage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) return;
    fetchLobbyByCode(code)
      .then((l) => navigate(`/lobby/${l.id}`, { replace: true }))
      .catch((e) => setError(e?.message ?? "Could not find lobby"));
  }, [code, navigate]);

  // Bounce home a moment after a failed lookup — typically the user
  // hit a stale link for a lobby that's already been reaped.
  useEffect(() => {
    if (!error) return;
    const t = setTimeout(() => navigate("/", { replace: true }), 1800);
    return () => clearTimeout(t);
  }, [error, navigate]);

  return (
    <main className="container">
      <div className="card-block">
        <h2>Joining lobby…</h2>
        {error ? (
          <>
            <p style={{ color: "var(--danger)" }}>{error}</p>
            <p className="muted">Returning home…</p>
          </>
        ) : (
          <p className="muted">Looking up code {code}…</p>
        )}
      </div>
    </main>
  );
}
